"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getInitials = function getInitials(customerName) {
  return customerName ? customerName.trim().split(' ').map(function (charset) {
    return charset[0].toUpperCase();
  }).filter(function (_char) {
    return _char && _char.match(/^[a-zA-Z]*$/);
  }).filter(function (_char2, index, arr) {
    return index === 0 || index === arr.length - 1;
  }).join('') : '';
};

var _default = getInitials;
exports["default"] = _default;
//# sourceMappingURL=getInitials.js.map